import React from 'react';
import { isBookingOpen } from '../shared/bookingGate';

/**
 * BookingNotLiveBanner (Jose 2026-10-13) — a big, always-visible red bar across the TOP of every portal
 * page until the Oct-19 cutover. People kept trying to book (and making orphan appointments) because the
 * "not live yet" message only showed when they hit a booking page. This puts it front-and-center app-wide:
 * your account/history/family is ready, but APPOINTMENTS still go through Fresha until Oct 19.
 */
const BookingNotLiveBanner: React.FC = () => {
  if (isBookingOpen()) return null;
  return (
    <div className="w-full bg-red-600 text-white text-center px-3 py-2 shadow-md sticky top-0 z-[90] leading-snug">
      <span className="font-extrabold">🚫 Booking isn't live yet.</span>{' '}
      <span className="font-medium">Please keep booking on <b>Fresha</b> until <b>Oct&nbsp;19</b> — SLIK appointments go live October&nbsp;19.</span>
    </div>
  );
};

export default BookingNotLiveBanner;
